import * as React from "react";
const SvgChevronLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.5 12.5L15 5L16.05 6.05L9.6 12.5L16.05 18.95L15 20L7.5 12.5Z", fill: "currentColor" }));
export default SvgChevronLeft;
